(() => {
  const customerLengthLabel = (text) => {
    const raw = String(text || '').trim();
    if (/extra\s+long/i.test(raw)) return 'Extra Long';
    if (/^long\b/i.test(raw)) return 'Long';
    if (/^medium\b/i.test(raw)) return 'Medium';
    if (/^short\b/i.test(raw)) return 'Short';
    return raw;
  };

  const tidyConciergeLengthLabels = (root = document) => {
    const concierges = [];
    if (root.matches?.('[data-hce-concierge]')) concierges.push(root);
    root.querySelectorAll?.('[data-hce-concierge]').forEach((node) => concierges.push(node));

    concierges.forEach((concierge) => {
      concierge.querySelectorAll('[data-hce-filter-group]').forEach((group) => {
        const heading = group.querySelector('summary > span:first-child');
        if (!heading || heading.textContent.trim().toLowerCase() !== 'length') return;
        group.querySelectorAll('.hce-concierge-option span').forEach((label) => {
          const current = label.textContent.trim();
          const cleaned = customerLengthLabel(current);
          if (cleaned !== current) label.textContent = cleaned;
        });
      });
    });
  };

  const run = () => tidyConciergeLengthLabels(document);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
  else run();

  document.addEventListener('shopify:section:load', (event) => tidyConciergeLengthLabels(event.target || document));

  let raf = 0;
  const observe = () => {
    if (!document.body) return;
    const observer = new MutationObserver(() => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => tidyConciergeLengthLabels(document));
    });
    observer.observe(document.body, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', observe, { once: true });
  else observe();
})();